export default "__VITE_PUBLIC_ASSET__6025f962__"